import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody54.css';

import clientimg from '../images/case-study-client54.webp'
import outcome from '../images/outcome54.webp'

import sm1 from '../images/cs54so1.webp'
import sm2 from '../images/cs54so2.webp'
import sm3 from '../images/cs54so3.webp'
import sm4 from '../images/cs54so4.webp'


const Casestudybody54 = () => {

    return (
        <>
        <section className='casestudybody54-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A sovereign wealth fund-backed hospitality management company operating a diversified portfolio of owned and third-party hotels nationwide, spanning across the ultra-luxury, luxury, upscale, and midscale segments</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client required an institutional-grade financial reporting template capable of translating complex financial performance into a clear, board-ready narrative to support governance, oversight, and capital allocation decisions by a non-operational Board, ExCom, and sovereign shareholders</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody54-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Requirement & Stakeholder Alignment</h4>
                          <p>Conducted a management kick-off to define reporting objectives, audience needs, and disclosure expectations-establishing scope, quarterly reporting cadence, currency, and accrual-basis presentation</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Data Architecture & Template Design</h4>
                          <p>Structured the underlying data model and built a standardised template spanning the executive summary, income statement, balance sheet, cashflow, working capital, opex, and capex-ensuring consistency, comparability, and a clear metric hierarchy across periods</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Metric Framework, Validation & Reconciliation</h4>
                          <p>Defined the KPI suite and variance logic (budget-vs-actual, QoQ/YoY) and embedded reconciliation controls to ensure figures tie out to audit-ready accuracy</p>
                        </div>
                      </div>
   
                     <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Insight & Assurance</h4>
                          <p>Translated the provided output into a concise, board-ready narrative, and finalised it through a layered human and Copilot quality-control process prior to delivery</p>
                        </div>

                        
                      </div>  

                  <div class="ai-section">

                    {/* <!-- Impact of AI --> */}
                    <div class="impact-panel">

                      <h2 class="section-heading">
                        <span class="heading-accent"></span>
                        Impact of AI
                      </h2>

                      <div class="impact-stat">
                        <span class="stat-arrow">▼</span>
                        <span class="stat-number" style={{marginRight:"30px"}}>~20</span>
                        <span class="stat-label">
                          Hours<br />
                          saved
                        </span>
                      </div>

                      <div class="impact-stat">
                        <span class="stat-arrow">▲</span>
                        <span class="stat-number">~33%</span>
                        <span class="stat-label">
                          Efficiency<br />
                          increased
                        </span>
                      </div>

                    </div>

                    {/* <!-- AI Integration --> */}
                    <div class="integration-panel">

                      <h2 class="section-heading">
                        <span class="heading-accent"></span>
                        AI-Integration
                      </h2>

                      <div class="integration-content">

                        {/* <!-- How AI was used --> */}
                        <div class="integration-column">

                          <h3 class="column-heading">
                            TOOL DEPLOYED
                          </h3>

                          <p class="column-description">
                            Microsoft 365 Copilot - Excel & Copilot in PowerPoint

                          </p>

                        </div>

                        {/* <!-- How AI was used --> */}
                        <div class="integration-column">

                          <h3 class="column-heading">
                            TECHNOLOGY
                          </h3>

                          <p class="column-description">
                            Generative AI / LLM-assisted template design, validation checks and narrative drafting
                          </p>

                        </div>

                        {/* <!-- How AI was used --> */}
                        <div class="integration-column">

                          <h3 class="column-heading">
                            WHAT WE AUTOMATED
                          </h3>

                          <p class="column-description">
                            Leveraged Microsoft 365 Copilot to accelerate the design of the financial reporting template and support automated validation of reporting outputs, enabling faster identification of inconsistencies and improving reporting quality
                          </p>

                        </div>

                        {/* <!-- How AI was used --> */}
                        <div class="integration-column">

                          <h3 class="column-heading">
                            HUMAN QC LAYER
                          </h3>

                          <p class="column-description">
                           Reconciled AI-extracted information with source charter documents, verified applicable liquidation and conversion mechanics, and integrated final inputs with company financials to ensure accurate, governance-compliant reporting

                          </p>

                        </div>

                        {/* <!-- Delivery Benefits --> 
                        <div class="integration-column delivery-benefits">

                          <h3 class="column-heading">
                            DELIVERY BENEFITS
                          </h3>

                          <ul class="benefits-list">
                            <li>Faster build of templates, workflows, and UI components</li>
                            <li>Quicker prototype iterations during stakeholder validation</li>
                            <li>Wider test coverage from AI-prepared test cases</li>
                            <li>Consistent code patterns and current technical documentation</li>
                            <li>Less repetitive coding, more time on business logic</li>
                          </ul>

                        </div>*/}

                      </div>
                    </div>

                  </div>
                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>

           


          </Container>
        </section>

    
        <section className='casestudybody54-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The engagement delivered a standardised, board-ready financial reporting template that enhanced transparency, strengthened period-on-period comparability, and improved decision making across the Board, ExCom, and other stakeholders.</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody54
